<div fxLayout="row">
    <div fxFlex="97">
        <h2 mat-dialog-title>Defina os filtros abaixo</h2>
    </div>
    <div fxFlex="3">
        <mat-icon style="cursor: pointer;" [mat-dialog-close]="true">close</mat-icon>
    </div>
</div>

<mat-dialog-content style="height: 360px;display: inline;">

    <div fxLayout="column" [formGroup]="formGroup">

        <fieldset>
            <label>Área</label>
            <ng-select [items]="area$ | async"
                       bindLabel="name"
                       formControlName="area"
                       bindValue="id"
                       placeholder="Área"
                       maxSelectedItems="3"
                       [multiple]="true"
                       [(ngModel)]="selectedArea">
            </ng-select>
        </fieldset>

        <fieldset>
            <label>Função</label>
            <ng-select [items]="funcao$ | async"
                       bindLabel="name"
                       bindValue="id"
                       formControlName="funcao"
                       placeholder="Função"
                       maxSelectedItems="3"
                       [multiple]="true"
                       [(ngModel)]="selectedFuncao">
            </ng-select>
        </fieldset>

        <fieldset>
            <label>Nível</label>
            <ng-select [items]="nivel$ | async"
                       bindLabel="name"
                       bindValue="id"
                       formControlName="nivel"
                       placeholder="Nível"
                       [multiple]="true"
                       [(ngModel)]="selectedNivel">
            </ng-select>
        </fieldset>

        <fieldset>
            <label>UF</label>
            <ng-select [items]="uf$ | async"
                       bindLabel="name"
                       bindValue="id"
                       formControlName="uf"
                       placeholder="UF"
                       [multiple]="true"
                       [(ngModel)]="selectedUf">
            </ng-select>
        </fieldset>

        <fieldset>
            <label>Status 123</label>
            <ng-select [items]="status$ | async"
                       bindLabel="name"
                       bindValue="id"
                       formControlName="status"
                       placeholder="Status"
                       [multiple]="true"
                       [(ngModel)]="selectedStatus">
            </ng-select>
        </fieldset>

    </div>

</mat-dialog-content>

<mat-dialog-actions align="end" style="height: 100px;">
    <button mat-button mat-raised-button color="primary" (click)="aplicarFiltro()" cdkFocusInitial>
        <mat-icon>push_pin</mat-icon>
        Aplicar Filtro
    </button>
</mat-dialog-actions>
